export default __webpack_public_path__ + "static/media/logo-drawer.20b8fc21.png";